import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { SettlementStatisticsConverterDetailAxisRevenueAppropriationPage } from '@/pages/settlement-statistics-converter/ui/SettlementStatisticsConverterDetailAxisRevenueAppropriationPage';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

/**
 * 歳入軸財源充当結果の検索パラメータスキーマ
 */
export const revenueAxisRevenueAppropriationSearchSchema = paginationSchema.extend({
  query_store_id: z.string().optional(),
  amount_unit: z.enum(amountUnitValues).optional(),
});

/**
 * 決算統計コンバーター結果詳細ルート（歳入軸財源充当結果タブ）
 */
export const Route = createFileRoute(
  '/_protected/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation',
)({
  component: () => <SettlementStatisticsConverterDetailAxisRevenueAppropriationPage />,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: revenueAxisRevenueAppropriationSearchSchema,
      defaultValues: undefined,
    }),
});
